import { render, staticRenderFns } from "./ProductInfoOverlay.vue?vue&type=template&id=45abcbfd&scoped=true&"
import script from "./ProductInfoOverlay.vue?vue&type=script&lang=js&"
export * from "./ProductInfoOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoOverlay.vue?vue&type=style&index=0&id=45abcbfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abcbfd",
  null
  
)

export default component.exports